<template>
	<el-card class="box-card">
		<div slot="header" class="clearfix">
			<span>授权详情</span>
			<span>
				<el-button v-if="data.freeze_state==1" type="warning" plain size="mini">当前状态：已授权</el-button>
				<el-button v-if="data.freeze_state==2" type="warning" plain size="mini">当前状态：违章押金</el-button>
				<el-button v-if="data.freeze_state==3" type="warning" plain size="mini">当前状态：已解冻</el-button>
			</span>
		</div>
		<div
			style="min-height: calc(100vh - 210px);background-color: white;display: flex;align-content: space-between;flex-wrap: wrap;">
			<el-row :gutter="20" style="width: 100%;height: 100%;">
				<el-col :span="8" style="height: 100%;">
					<el-card class="box-card" style="height: 100%;">
						<div slot="header" class="clearfix">
							<span>授权信息</span>
							<span>
								<el-button type="success" plain size="mini">授权金额：{{data.freeze_amount}}</el-button>
							</span>
						</div>
						<div style="height: 100%;">
							<el-form ref="form" :model="data" label-width="auto" style="height: 100%;">
								<el-form-item label="门店名称">
									<el-input disabled v-model="data.store_name"></el-input>
								</el-form-item>
								<el-form-item label="授权方式">
									<el-input disabled v-model="data.freeze_type"></el-input>
								</el-form-item>
								<el-form-item label="授权金额">
									<el-input disabled v-model="data.freeze_amount"></el-input>
								</el-form-item>
								<el-form-item label="客户姓名">
									<el-input disabled v-model="data.user_name"></el-input>
								</el-form-item>
								<el-form-item label="客户手机">
									<el-input disabled v-model="data.user_tel"></el-input>
								</el-form-item>
							</el-form>
						</div>
					</el-card>
				</el-col>
				<el-col :span="8">
					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<span>授权操作信息</span>
							<span>
								<el-button type="success" plain size="mini"
									icon="el-icon-success">剩余授权金额{{data.amount_balance}}</el-button>
							</span>
						</div>
						<div style="height: 100%;">
							<template>
								<el-table :data="data.actions" style="width: 100%">
									<el-table-column prop="action_date" label="日期" width="180">
										<template slot-scope="scope">
											{{timeFormat(scope.row.action_date,'yyyy-mm-dd hh:MM:ss')}}
										</template>
									</el-table-column>
									<el-table-column prop="action_amount" label="金额" width="180">
									</el-table-column>
									<el-table-column prop="action_name" label="操作">
									</el-table-column>
								</el-table>
							</template>
						</div>
					</el-card>
				</el-col>
				<el-col :span="8">
					<el-card class="box-card">
						<div slot="header" class="clearfix">
							<span>扣款信息</span>
							<span>
								<el-button type="success" plain size="mini"
									icon="el-icon-success">总扣款{{data.total_pay_amount}}</el-button>
							</span>
						</div>
						<div style="height: 100%;">
							<el-table :data="data.payments" style="width: 100%">
								<el-table-column prop="action_date" label="日期" width="180">
									<template slot-scope="scope">
										{{timeFormat(scope.row.payment_date,'yyyy-mm-dd hh:MM:ss')}}
									</template>
								</el-table-column>
								<el-table-column prop="payment_amout" label="金额" width="100">
								</el-table-column>
								<el-table-column prop="action_date" label="图片" width="100">
									<template slot-scope="scope">
										<el-button type="success" size="mini"
											@click="imageList=toArray(scope.row.payment_img),dialog.img=true">查看</el-button>
									</template>
								</el-table-column>
								<el-table-column prop="freeze_type_name" label="项目">
								</el-table-column>
							</el-table>
						</div>
					</el-card>
				</el-col>
			</el-row>


			<el-dialog title="图片预览" :visible.sync="dialog.img" :fullscreen="true" top="0" custom-class="showImgClass"
				:modal="false" style="width: 100%;height: calc(100vh);background: rgba(0, 0, 0, 0.2);">
				<el-image v-for="item in imageList" style="width: 100%; height: 100%" :src="item"
					fit="contain"></el-image>
				<div style="width: 100%;position: fixed;top: 10px;display: flex;justify-content: center;"><el-button type="danger" size="medium" style="width: 30%;" @click="dialog.img=false">关闭</el-button>
				</div>

			</el-dialog>

		</div>
	</el-card>
</template>

<script>
	export default {

		data() {
			return {
				dialog: {
					img: false
				},
				imageList: [],
				data: {},
				freeze_id: ''
			}
		},
		mounted() {
			var that = this;
			this.freeze_id = this.$route.query.freeze_id;
			setTimeout(function() {
				that.getData();
			}, 500);
		},
		methods: {
			toArray(str) {
				var arry = str.split(",");
				for (var i = 0; i < arry.length; i++) {
					arry[i] = this.host + arry[i];
				}
				return arry;
			},
			getData() {
				var that = this;
				this.$axios.post('zuche/store/getFreezeList', {
					freeze_id: this.freeze_id
				}).then(function(res) {
					console.log(res);
					if (res.data.success) {
						that.data = res.data.result.freezes[0];

					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		}
	}
</script>

<style>
	.showImgClass {
		background-color: rgba(0, 0, 0, 0.2);
	}
</style>


// WEBPACK FOOTER //
// src/components/freezeInfo.vue